/**
 * Root route for Link Admin.
 *
 * Houses the typed RouterContext (auth store + queryClient from createAppRoot).
 * Child routes read `context.auth.getSnapshot()` via requireAuth / requireRole.
 *
 * `<Toaster>` is mounted here (parity with hr-admin + employee-web) so any
 * route — authenticated or not — that calls `useToast()` finds a provider.
 * Without this hoist, `AdminInviteResendButton` (and any future unauth flow)
 * crashes with "useToast must be used inside <Toaster>" before the page
 * renders.
 */
import { Outlet, createRootRouteWithContext } from "@tanstack/react-router";
import { Toaster } from "@linkhr/design-system";
import type { RouterContext } from "@linkhr/auth/guards";

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootComponent,
});

function RootComponent(): React.JSX.Element {
  return (
    <Toaster>
      <Outlet />
    </Toaster>
  );
}
